import { NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeBn from '@angular/common/locales/bn';

// Dates, numbers and prices on the Bangla pages - lakh and crore grouping (LOCALE_ID comes from the URL: CULTURE_PROVIDERS).
registerLocaleData(localeBn, 'bn');

// Every date pipe says Bangladesh time (UTC+6), whoever looks and wherever the page is drawn (shared/site-time).
import './shared/site-time';

// modules (angular)
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// modules (third-party)
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';

// modules
import { AppRoutingModule } from './app-routing.module';
import { BlocksModule } from './modules/blocks/blocks.module';
import { FooterModule } from './modules/footer/footer.module';
import { HeaderModule } from './modules/header/header.module';
import { MobileModule } from './modules/mobile/mobile.module';
import { SharedModule } from './shared/shared.module';
import { WidgetsModule } from './modules/widgets/widgets.module';

// components
import { AppComponent } from './app.component';
import { RootComponent } from './components/root/root.component';

// pages
import { PageHomeOneComponent } from './pages/page-home-one/page-home-one.component'; 
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PageOffcanvasCartComponent } from './pages/page-offcanvas-cart/page-offcanvas-cart.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';  
import { PageProgressInterceptor } from './shared/interceptors/page-progress.interceptor';
import { AuthGuard } from './shared/interceptors/auth-guard.service'; 
import { CULTURE_PROVIDERS } from './shared/culture/culture.module';


@NgModule({
    declarations: [
        // components
        AppComponent,
        RootComponent,
        // pages
        PageHomeOneComponent, 
        PageNotFoundComponent,
        PageOffcanvasCartComponent
    ],
    imports: [
        // modules (angular)
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        BrowserTransferStateModule,
        // Once, here: the ONE HttpClient, which carries the AuthInterceptor everywhere (see SharedModule).
        HttpClientModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule,
        // modules (third-party)
        CarouselModule,
        ToastrModule.forRoot(),    
        // modules
        AppRoutingModule,
        BlocksModule,
        FooterModule,
        HeaderModule,
        MobileModule,
        SharedModule,
        WidgetsModule,
       // EditorModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        // The loading bar: counts the requests a page makes while it opens.
        { provide: HTTP_INTERCEPTORS, useClass: PageProgressInterceptor, multi: true },
        AuthGuard,
        // The page's labels before its first draw, LOCALE_ID from the URL, its language on every API call (shared/culture).
        ...CULTURE_PROVIDERS
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
